<template>
  <b-row class="d-flex align-items-stretch">
    <b-col
      cols="12"
      md="6"
      xl="4"
      v-for="event in events"
      :key="event.url"
      class="mb-4"
    >
      <div class="event-card d-flex flex-column">
        <img :src="event.image" class="img-fluid" alt="Event thumbnail" />
        <div
          class="event-details flex-grow-1 d-flex flex-column justify-content-between"
          style="background-color: #f8f9fa"
        >
          <div>
            <h5 class="mb-3">{{ event.title }}</h5>
            <div
              class="session-tag bg-blue d-inline-flex align-items-center justify-content-center"
            >
              <img
                src="https://res.cloudinary.com/oredev/image/upload/v1716803684/2024/Icons.svg/calendar_white.svg"
                class="mr-1"
                alt="Calendar Icon"
              />
              <span>{{ event.date }}</span>
            </div>
            <div
              class="session-tag bg-blue d-inline-flex align-items-center justify-content-center"
            >
              <img
                src="https://res.cloudinary.com/oredev/image/upload/v1716803684/2024/Icons.svg/clock_white.svg"
                class="mr-1"
                alt="Clock Icon"
              />
              <span>{{ event.time }}</span>
            </div>
            <div
              class="session-tag bg-blue d-inline-flex align-items-center justify-content-center"
            >
              <img
                src="https://res.cloudinary.com/oredev/image/upload/v1716803684/2024/Icons.svg/location_white.svg"
                class="mr-1"
                alt="Location Icon"
              />
              <span>{{ event.location }}</span>
            </div>
            <p class="mt-3 mb-3">{{ event.summary }}</p>
          </div>
          <div>
            <a
              :href="event.url"
              target="_blank"
              class="btn-event d-inline-flex align-items-center justify-content-center"
            >
              Sign up to the event
              <i class="material-icons ml-1">open_in_new</i>
            </a>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  data() {
    return {
      events: [
        {
          url: "https://www.meetup.com/net-skane/events/303722742/",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1718612135/2024/Oredev%2B/OredevPlusEventSkåne.png",
          title: ".NET Skåne November - Øredev warmup 🥂",
          date: "Monday, November 4th",
          time: "05:00 to 07:00pm → 2h",
          location: "Corechange, Malmborgsgatan 7 · Malmö",
          summary:
            "This is your chance to get a sneak peek of what’s to come at the Øredev conference, connect with fellow developers, and get energized for the big event. Join us for an evening filled with insightful talks, networking, and great company. Whether you're attending Øredev or just want to learn and mingle with the community, this event is the perfect warmup!!",
        },
        {
          url: "https://simplesignup.se/event/220858",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1718612135/2024/Oredev%2B/EventThumbnailPlaceHolder.png",
          title: "Unleashing Innovation: Connecting the dots in leadership",
          date: "Tuesday, November 5th",
          time: "10:00am to 12:00 → 2h",
          location: "STPLN, Malmöhusvägen 5, 211 18 Malmö",
          summary:
            "In this engaging 2-hour session at STPLN, we will explore how cultivating psychological safety and inclusive leadership can ignite innovation and drive team success. Through interactive activities and thought-provoking discussions, participants will learn actionable strategies to create environments where creativity thrives, diverse voices are amplified, and bold ideas take shape.",
        },
        {
          url: "https://foocafe.org/event/ai-pair-programming-github-copilot",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1718612135/2024/Oredev%2B/OredevPlusEventPair.png",
          title: "AI Pair Programming with Github Copilot by Foo Café",
          date: "Tuesday, November 5th",
          time: "5:30 to 8:00pm → 2h30",
          location: "Slagthuset, Carlsgatan 12a, 211 20 Malmö",
          summary:
            "In this session, you will learn about how Github Copilot can assist developers in their day-to-day programming i.e jumpstart a new project with a new code base as the starting foundation, faster & more efficient error resolution & enhanced code quality by suggesting code improvements.",
        },
        {
          url: "https://www.eventbrite.se/e/redev-devoteams-after-work-biljetter-1022358280137?aff=oddtdtcreator",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1718612135/2024/Oredev%2B/OredevPlusEventDevo.png",
          title: "Øredev + Devoteam's After Work",
          date: "Thursday, November 7th",
          time: "05:00 to 09:00pm → 4h",
          location:
            "Skybar @ Malmö Arena Hotel, 12 Hyllie Boulevard 215 32 Väster",
          summary:
            "Network with fellow tech enthusiasts, unwind after a day of learning, and enjoy great company. This in-person event is the perfect opportunity to connect with like-minded individuals in a relaxed setting.",
        },
        {
          url: "https://foocafe.org/event/do-we-need-dictator-leadership",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1718612135/2024/Oredev%2B/OredevPlusEventLeadership.png",
          title: "DO WE NEED DICTATOR LEADERSHIP? by FooCafé",
          date: "Thursday, November 7th",
          time: "05:30 to 08:00pm → 2h30",
          location: "Slagthuset, Carlsgatan 12a, 211 20 Malmö",
          summary:
            "Until recently, everyone wanted Agile coaches. Today, the demand is in decline. What will be the next trend? There are so many different leadership styles we can use. Could the next trend be a dictator? This session delves into the essence of leadership, roles, and team dynamics, leveraging real-world experiences to discern the most suitable leadership styles for teams at various stages of maturity.",
        },
        {
          url: "https://lu.ma/p47d7746",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1718612135/2024/Oredev%2B/OredevPlusEventGround.png",
          title: "The Ground X Øredev+ Cozy Get Together AW",
          date: "Thursday, November 7th",
          time: "05:30 to 09:00pm → 4h30",
          location: "The Ground, Bredgatan 4, 211 30 Malmö",
          summary:
            "Come wind down after a day at the Øredev Conference by networking and enjoying good company at The Ground with our official Øredev+ side event. Join us for a relaxing evening with beer and pizza. Play some ping-pong, make new connections, and relax on our comfy couches.",
        },
        {
          url: "https://www.mediaevolution.se/program-details/ai-and-creativity",
          image:
            "https://res.cloudinary.com/oredev/image/upload/v1718612135/2024/Oredev%2B/OredevPlusEventAI.png",
          title: "AI and Creativity by Media Evolution City",
          date: "Friday, November 8th",
          time: "01:00 to 03:00pm → 2h",
          location: "Malmö Konstmuseum",
          summary:
            "What is the role of humans in the future of creative work? Who owns what? Can creatives opt out of letting their work train the machine learning algorithms? What happens if advanced tools for creative expression are increasingly made available to all, in a new era of digital democratisation? What’s the value of creative work? What could, and will, a symbiotic relationship between humans, nature, technology and audiences look like?",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

p {
  color: $text-dark;
}
span {
  color: $text-color-light;
}
h5 {
  font-size: 20px !important;
}
.session-tag {
  font-family: Outfit, Geneva, Tahoma, sans-serif;
  font-size: 14px;
  font-weight: 300;
  padding: 4px 7px;
  border-radius: 5px;
  margin-right: 3px;
  margin-bottom: 5px;
}
.btn-event {
  background: #f9aa41;
  height: 40px !important;
  width: 100%;
  border-radius: 30px;
  color: $text-dark !important;
  font-size: 20px !important;
  font-weight: 400 !important;
  text-decoration: none !important;
}
.btn-event:hover {
  background: #d89338 !important;
}
.event-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.event-details {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/OredevPlusEvents.vue